import { PhotoForm } from '@/components/PhotoForm';
import useRoutePhoto from '@/hooks/useRoutePhoto';

export const EditPhotoPane = () => {
  const { photo } = useRoutePhoto();
  if (!photo) { return null; }

  return (
    <div className="w-full h-full">
      <PhotoForm photo={photo} />
    </div>
  );
};
